import styled from '@emotion/styled';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  gap: 23px;
`;

export const Title = styled.div`
  font-size: 20px;
  line-height: 23px;
  font-family: NokiaPureText-Regular;
  text-align: center;
  color: ${({ theme }) => theme.colors.blueBlack};
`;

export const BtnsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
